export default __webpack_public_path__ + "media/onboarding/welcome_insights-1e7930ed.png";